import { schema } from 'normalizr';

const accountGOSAvailableStatistics = new schema.Entity(
  'accountGOSAvailableStatistics'
);

export default accountGOSAvailableStatistics;
